import SchedulePage from 'enums/SchedulePageEnum';

export const unifiedScheduleConfigurations = {
  advanced: {
    autoLoad: false,
    disableIfPast: false,
    enableDatePicker: true,
    pageTitle: SchedulePage.ADVANCED,
    showVersion: true,
    showAmend: true,
    showGenerate: false,
    showGeneratePresentation: true,
    showOp2mise: false,
    showSubmit: false,
    initialStartDateOffset: 0, // in days, used to set default start date to tomorrow
  },
  standby: {
    pageTitle: SchedulePage.STANDBY,
    showVersion: true,
    showGeneratePresentation: false,
    showSubmit: true,
    showAmend: false,
    enableDatePicker: false,
    autoLoad: true,
    customDateRange: {
      start: new Date(2099, 0, 1),
      end: new Date(2099, 0, 8),
    },
    sampleTemplate: 'standbyScheduleImportTemplate',
    disableIfPast: false,
  },
  new: {
    pageTitle: SchedulePage.NEW,
    showVersion: false,
    showGeneratePresentation: false,
    showSubmit: true,
    showAmend: false,
    showGenerate: true, // new page only
    enableDatePicker: true,
    autoLoad: false,
    showOp2mise: true,
    disableIfPast: true,
    initialStartDateOffset: 1, // in days, used to set default start date to tomorrow
  },
};
